module.exports = __webpack_public_path__ + "static/media/404.886750fd.svg";